export default {
  'm': {
    'uploading': 'กำลังอัปโหลด...',
    'upload_failed': 'อัปโหลดไม่สำเร็จ',
    'EnterID': 'กดคลิกเพื่อป้อนเข้า BuzzCast ID',
    'select-specifications': 'กดคลิกเพื่อเลือกสเปคที่ต้องการเติมเงิน',
    'check-account': 'ตรวจสอบหมายเลขบัญชีที่ต้องการเติมเงิน',
    'whatID': ' BuzzCast ID คืออะไร?',
    'getID': 'ป้อนเข้า BuzzCast ID',
    'maskgetID': 'ป้อนเข้า BuzzCast ID',
    'toastTips-format-error': 'รูปแบบในการป้อนเข้าผิดพลาด',
    'toastTips-no-exist': 'ไม่พบ ID นี้ในระบบ',
    'toastTipsPlease': 'กรุณาตรวจสอบหมายเลขบัญชีที่ต้องการเติมเงิน',
    'common-problem': 'ปัญหาที่พบบ่อย',
    'transaction-succeeded': 'ธุรกรรมสำเร็จ',
    'transaction-failed': 'ธุรกรรมล้มเหลว',
    'transaction-cancel': 'ยกเลิกธุรกรรม',
    'whether-account': '1.หลังจากที่ฉันเติมเงินเสร็จแล้ว ถ้าจะตรวจดูว่าเงินเข้าบัญชีหรือยังจะต้องทำอย่างไร?',
    'answer-whether-account': 'หลังจากเติมเงินเสร็จสามารถกลับมาที่app (ของฉัน)-(กระเป๋าเงิน) เพื่อตรวจดูเพชร',
    'no-account': '2.หลังจากเติมเงินเสร็จแล้วถ้าเงินไม่เข้าบัญชีจะต้องทำอย่างไร?',
    'answer-no-account': 'กรุณาเปิดappแล้วเข้าไปที่(ข่าวคราว)-(ข่าวคราวทางการ)-(ฟีดแบคและความช่วยเหลือ) รบกวนแจ้งปัญหาของท่านในนี้ และกรอกข้อความดังต่อไปนี้ด้วย ฝ่ายบริการลูกค้าของเราจะมอบความช่วยเหลือแก่ท่าน',
    'recharge-money': '1. ยอดเงินและ IDบัญชีที่ต้องการเติมเงิน',
    'recharge-time': '2.วันที่และเวลาที่เติมเงิน',
    'recharge-shot': '3.ภาพตัดหน้าจอที่ชำระเงินได้สำเร็จ',
    'recharge-wrong': '3.การเติมเงินผิดบัญชี การเติมยอดเงินผิดจะต้องทำอย่างไร',
    'answer-recharge-wrong': 'กรุณาตรวจยืนยัน ID บัญชีและยอดเงินที่ต้องการเติมเงินอย่างละเอียดถี่ถ้วน ก่อนที่ท่านจะป้อนเข้ารหัสผ่านเพื่อชำระเงิน หากเติมยอดเงินผิดพลาดจะไม่สามารถนำเงินดังกล่าวคืนกลับมาได้ หากเติมเงินผิดบัญชีไป ท่านลองติดต่อกับ ID ที่ได้เติมเงินจริงนั้นดูก่อน ขอความกรุณาจากอีกฝ่ายว่าจะยินยอมชดเชยเงินดังกล่าวให้ท่านหรือไม่',
    'refund': '4.คืนเงิน',
    'answer-refund': 'ขออภัยค่ะ ปัจจุบันนี้BuzzCastไม่สนับสนุนการคืนเงินในรูปแบบใดทั้งสิ้น',
    'buy-enter-link': 'การซื้อเพชรสามารถเติมเงินโดยผ่านลิงก์นี้ได้ <a class="web-link" href="https://pay.buzzcast.info">https://pay.buzzcast.info</a> คัดลอกลิงก์นี้ไปวางไว้ที่เบราว์เซอร์ในมือถือเพื่อเปิดออก จากนั้นเข้าสู่หน้าเว็บการสั่งซื้อ หลังตรวจสอบหมายเลขบัญชีเสร็จแล้ว ให้เลือกสเปคที่สอดคล้องกันและเลือกใช้วิธีชำระเงินที่เหมาะสมเพื่อทำการชำระเงิน ซึ่งได้จัดส่วนลดไว้มากมาย! ',
    'buy-notice-a': 'หมายเหตุ: <a>{msg}</a> เป็นเว็บไซต์ซื้อเพชรอย่างเป็นทางการเพียงแห่งเดียวสำหรับ BuzzCast',
    'replace': 'เปลี่ยนใหม่',
    'sureBtn': 'กำหนด',
    'pay-style': 'เลือกวิธีการชำระเงิน',
    'goBack': 'กลับไปที่หน้าแรก',
    'toastTips': 'ป้อนเข้า BuzzCast ID',
    'rechargeFAQ_title': 'ปัญหาที่พบบ่อย',
    'PayStatusSuccess_title': 'ธุรกรรมสำเร็จ',
    'PayStatusFail_title': 'ธุรกรรมล้มเหลว',
    'PayStatusCancel_title': 'ยกเลิกธุรกรรม',
    'Diamonds_title': 'เว็บไซต์เติมเพชรอย่างเป็นทางการของ {msg}',
    'buy-notice': 'โปรดทราบว่า  pay.buzzcast.info เป็นเว็บไซต์ซื้อเพชรอย่างเป็นทางการสำหรับ BuzzCast เท่านั้นสำหรับการสอบถามการบริการลูกค้าโปรดไปที่ [ข้อความ] - [ข่าวอย่างเป็นทางการ] - [ข้อเสนอแนะและความช่วยเหลือ]',
    'RechargeHelp_title': 'ช่วยเหลือการเติมเงิน',
    'RechargeProblem_title': 'การเติมเงินของคุณพบปัญหา,',
    'feedback_and_help': 'ข้อเสนอแนะและความช่วยเหลือ',
    'problem_screenshot': 'ภาพหน้าจอคำถาม/การบันทึกหน้าจอ ({msg})',
    'problem_description': 'คำอธิบายคำถาม',
    'problem_description_placeholder': 'โปรดอธิบายคำถามที่คุณพบ',
    'optional': 'ไม่บังคับ',
    'required': 'ที่จำเป็น',
    'openAPP': 'เปิดแอป BuzzCast',
    'buy-diamonds-tit': 'ซื้อบริการเพชร',
    'description': 'เว็บเพชรแบบชาร์จได้เพียงแห่งเดียวคือ BuzzCast อย่างเป็นทางการ BuzzCast เป็นแอปโซเชียลระดับสากลผู้ใช้อยู่ในกว่า 150 ประเทศและภูมิภาคทั่วโลกกําลังใช้ BuzzCast อยู่',
    'keywords': 'ชาร์จ BuzzCast, เติมเพชร BuzzCast, อย่างเป็นทางการ BuzzCast โหลด, เว็บไซต์อย่างเป็นทางการเติม BuzzCast',
    'payforType': ' วิธีการเติมเงิน',
    'trueText': 'กำหนด',
    'falseText': 'ยกเลิก',
    'alertShowTxt1': 'แน่ใจหรือว่าใช้',
    'alertShowTxt3': ' ในการเติมเพชร',
    'alertShowTxt5': '',
    'EnterIDTip': 'เติมเงินด่วน {msg}',
    'scanLogin': 'เพื่อความเป็นส่วนตัวและความปลอดภัยของบัญชีโปรดสแกนรหัสเพื่อเข้าสู่ระบบ',
    'scanTip': 'เคล็ดลับ: คลิก "สแกน" ที่มุมขวาบนของ BuzzCast "ศูนย์ส่วนบุคคล / พลวัต" เพื่อสแกนรหัสเพื่อเข้าสู่ระบบในขณะเดียวกันก็รองรับการเข้าสู่ระบบโดยระบุภาพหน้าจอรหัส QR',
    'scanVersion': 'โปรดอัปเกรด BuzzCast เป็นเวอร์ชัน %s และสแกนรหัสเพื่อเข้าสู่ระบบ',
    'delAccount': 'การลบบัญชี',
    'logout': 'เลิกทำ',
    'submit': 'เสนอ',
    'email_place_holder': 'ใส่อีเมลของคุณ',
    'fill_in_email_address': 'กรุณากรอกอีเมล์',
    'fill_in_all_required': 'กรุณาใส่คำอธิบายคำถาม',
    'order_exception_notice': 'การแจ้งเตือนอย่างอบอุ่น: ต้องระบุหมายเลขคำสั่งซื้อหรือภาพหน้าจอใบเรียกเก็บเงินสำหรับคำสั่งซื้อการเติมเงินที่ผิดปกติ',
    'cannot_read_file': 'ไม่สามารถอ่านไฟล์ได้',
    'upload_file_exceed_limit': 'ไฟล์ที่อัปโหลดต้องมีขนาดไม่เกิน {num} MB',
    'submitting': 'กำลังส่ง...',
    'submit_failed': 'การส่งล้มเหลว',
    'contact_email': 'อีเมลติดต่อ',
    'provide_email': 'โปรดระบุที่อยู่อีเมลของคุณเพื่อรับการแจ้งการชำระเงิน',
    'email_address': 'ที่อยู่อีเมล',
    'sel_country_area': 'เลือกประเทศหรือภูมิภาค',
    'search_for': 'ค้นหา',
    'login': 'เข้าสู่ระบบ',
    'scan_login': 'การสแกนรหัสเข้าสู่ระบบ',
    'account_password_error': 'หมายเลขโทรศัพท์หรือรหัสผ่านไม่ถูกต้อง',
    'user_frozen': 'ผู้ใช้ถูกตรึง',
    'account_no_reg': 'บัญชีไม่ได้ลงทะเบียน',
    'login_no': 'คุณยังไม่ได้เข้าสู่ระบบ',
    'login_after_recharge': 'คุณสามารถเติมเงินได้หลังจากเข้าสู่ระบบ',
    'scan_login_lesson': 'บทช่วยสอนการสแกนรหัสเข้าสู่ระบบ',
    'scan_login_desc': 'วิธีการสแกนรหัสการเข้าสู่ระบบสามารถตระหนักได้อย่างรวดเร็วและปลอดภัยในการเข้าสู่ระบบการเติมเงิน วิธีการสองวิธีต่อไปนี้จะแนะนำวิธีการสแกนรหัสเพื่อเข้าสู่ระบบ',
    'scan_login_a_title': 'เข้าสู่ระบบด้วยการจดจำภาพหน้าจอของรหัส QR',
    'scan_login_a_p1': '1. เหมาะสำหรับการใช้สถานการณ์ของอุปกรณ์เดียว ผู้ใช้ป้อนหน้าล็อกอินของเว็บไซต์เติมเงินคลิกเพื่อเลือก "สแกนโค้ดเพื่อเข้าสู่ระบบ" และจับภาพหน้าจอของหน้าเว็บที่มีรหัสการเข้าสู่ระบบจะปรากฏขึ้นและบันทึกอัลบั้ม (ฟังก์ชั่นหน้าจอแตกต่างกันเล็กน้อยสำหรับอุปกรณ์ที่แตกต่างกันคุณสามารถค้นหาคำแนะนำการใช้งานของฟังก์ชั่นหน้าจอด้วยตัวเอง)',
    'scan_login_a_p2': '2. เปิดแอป BuzzCast ผ่านโมดูลฟังก์ชั่น "ศูนย์ส่วนบุคคล" หรือ "ไดนามิก" คลิก "สแกน" ที่มุมขวาบนเพื่อเข้าสู่โมดูลฟังก์ชั่นการสแกนโค้ด',
    'scan_login_a_p3': '3. คลิก "การเลือกอัลบั้ม" และอนุญาตให้อนุญาตอัลบั้มให้เลือกภาพหน้าจอของหน้าล็อกอินของรหัส QR ที่บันทึกไว้คลิกปุ่มยืนยัน "เข้าสู่ระบบ" หลังจากที่ระบบรับรู้ให้สลับกลับไปที่เบราว์เซอร์แล้วรอสักครู่หน้าเว็บจะโหลดผู้ใช้โดยอัตโนมัติ ข้อมูล.',
    'scan_login_b_title': 'เข้าสู่ระบบโดยสแกนรหัส QR',
    'scan_login_b_p1': '1. เหมาะสำหรับการใช้งานอุปกรณ์หลายเครื่อง ผู้ใช้ป้อนหน้าล็อกอินของเว็บไซต์เติมเงินและคลิกเพื่อเลือก "สแกนรหัสเข้าสู่ระบบ',
    'scan_login_b_p2': '2. เปิดแอป BuzzCast บนอุปกรณ์อื่นไปที่โมดูลฟังก์ชั่น "ศูนย์ส่วนบุคคล" หรือ "ไดนามิก" และคลิก "สแกน" ที่มุมบนขวาเพื่อเข้าสู่โมดูลฟังก์ชั่นการสแกนโค้ด',
    'scan_login_b_p3': '3. จัดตำแหน่งกล่องสแกนรหัสด้วยรหัส QR ในหน้าล็อกอินการสแกนโค้ดคลิกปุ่มยืนยัน "เข้าสู่ระบบ" หลังจากที่ระบบรับรู้ (แนะนำให้เก็บระยะห่างที่แน่นอนระหว่างอุปกรณ์เมื่อสแกนรหัสซึ่งง่ายขึ้น สำหรับระบบที่จะรับรู้) หลังจากนั้นไม่นานหน้าหน้าจะโหลดข้อมูลผู้ใช้โดยอัตโนมัติ',
    'scan_login_lesson_end': 'ข้างต้นเป็นคู่มือการสอนสำหรับการเข้าสู่ระบบการสแกนฉันหวังว่าจะช่วยคุณ สำหรับการให้คำปรึกษาการบริการลูกค้าโปรดป้อนข่าวแอป - ข่าวสารอย่างเป็นทางการ - ข้อเสนอแนะและความช่วยเหลือ',
    'or': 'หรือ',
    'input_phone_num': 'เบอร์โทรศัพท์ต้องไม่ว่างเปล่า',
    'input_email': 'กรุณาใส่ที่อยู่อีเมล',
    'input_password': 'ใส่รหัสผ่าน',
    'log_in_using_Facebook': 'เข้าสู่ระบบด้วย Facebook',
    'log_in_using_Google': 'เข้าสู่ระบบด้วย Google',
    'account_or_pwd_error': 'บัญชีหรือรหัสผ่านไม่ถูกต้อง',
    'pay_fail_system_risk': 'การทำธุรกรรมล้มเหลว: ระบบผิดปกติ',
    'recharge_fail_risk_network': 'การเติมเงินล้มเหลว คุณอาจอยู่ในสภาพแวดล้อมเครือข่ายที่มีความเสี่ยงสูงหรือด้วยเหตุผลอื่น หากคุณต้องการความช่วยเหลือเกี่ยวกับการเติมเงิน กรุณาแจ้งปัญหาของคุณให้เราทราบ',
    'friendly_tip': 'ทิปอุ่นๆ',
    'i_got_it': 'ฉันเข้าใจแล้ว',
    'android_fblogin_tip': 'เนื่องจาก Facebook ไม่รองรับการเข้าสู่ระบบการตรวจสอบสิทธิ์บนเบราว์เซอร์ที่ฝังตัวของ Android อีกต่อไป คุณอาจไม่สามารถเข้าสู่ระบบได้เมื่อคุณเข้าสู่ระบบด้วยวิธีนี้ หากคุณพบปัญหาการเข้าสู่ระบบประเภทนี้ โปรดใช้เบราว์เซอร์ Chrome เพื่อเข้าถึง',
    'recharge_tip': 'จำนวนเพชรที่เข้าบัญชีนั้นขึ้นอยู่กับจำนวนเงินที่เติมจริง',
    'charge': 'เติมเงิน',
    'link_add_mainpage': 'เพิ่มลิงค์ไปยังหน้าจอหลักสำหรับการโหลดครั้งต่อไป',
    'click_me_to_add': 'คลิกฉันเพื่อเพิ่ม',
    'user_has_delete': 'ผู้ใช้ออกจากระบบ',
    'support_contant_whatsapp': 'หากคุณต้องการความช่วยเหลือ โปรดติดต่อฝ่ายบริการลูกค้าบน {msg} App：1924383',
    'buy_balance': 'ยอดคงเหลือที่ซื้อได้:',
    'official_coin_seller': 'ผู้ค้าเหรียญอย่างเป็นทางการ',
    'paystyle_unavailabel_change_other': 'ระบบล้มเหลว วิธีการชำระเงินนี้ใช้ไม่ได้ชั่วคราว คุณสามารถเปลี่ยนวิธีการชำระเงินอื่นได้',
    'failedPay': 'การจ่ายเงินมีปัญหาการจ่ายเงินซ้ำ',
    "copied": "คัดลอกแล้ว",
    "reseller": "เอเจนซี่",
    "netword_busy_try": "เครือข่ายไม่ว่างโปรดลองอีกครั้ง",
    "placecommen": 'กรุณาใส่การค้นหาของคุณ',
    "app_all_v2": 'ตลอดเดือนนี้',

		"use_phone_login": `เข้าสู่ระบบด้วยโทรศัพท์`,
    "use_email_login": `เข้าสู่ระบบด้วยอีเมล`,
    "device_is_more": "จำนวนบัญชีที่ลงทะเบียนสำหรับอุปกรณ์นี้ถึงขีดจำกัดสูงสุดแล้ว",
    "Operation_failed": "อุปกรณ์นี้ถูกแช่แข็งอย่างถาวรเนื่องจากการละเมิดบัญชี",
    "connection_fail_retry_feedback": "การเชื่อมต่อล้มเหลว กรุณาตรวจสอบให้แน่ใจว่าเครือข่ายทำงานได้อย่างราบรื่นและลองอีกครั้ง หากคุณยังคงพบข้อผิดพลาด กรุณาแจ้งให้เราทราบ และเราจะแก้ไขให้คุณโดยเร็วที่สุด",
    "fawry_recharge_failed": "การเติมเงิน ${msg} ผ่าน {method} ไม่สำเร็จ",
    "feedback": "ข้อเสนอแนะ",
    "problem_feedback": "ข้อเสนอแนะปัญหา",
    "recommended_recharge_methods": "วิธีการชำระเงินที่แนะนำ",
    "try_recharge_methods": "กรุณาลองเติมเงินโดยใช้วิธีการต่อไปนี้ หากคุณยังพบปัญหา ให้คลิกปุ่ม \"{feedback}\" ด้านล่างเพื่อติดต่อเรา",
    "unable_recharge": "ไม่สามารถเติมเงินได้",
    "submitted_successfully": "ส่งเรียบร้อย",
    "feedback_success_tip": "ขอบคุณสำหรับความคิดเห็นของคุณ เราจะดำเนินการโดยเร็วที่สุดภายใน 24 ชั่วโมง",
    "completed": "เสร็จ สมบูรณ์",
    'contact_information': 'รายละเอียดการติดต่อ (ไม่บังคับ)',
    'pay_failed': 'การชำระเงินล้มเหลว',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/th.js